// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Z0zS","notes":"Notes_notes__1EHVQ"};